import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/layout/Layout";
import RequireAuth from "./pages/RequireAuth";
import RootGate from "./pages/RootGate";
import Learn from "./pages/Learn";
import Auth from "./pages/Auth";
import Verify from "./pages/Verify";
import Problem from "./components/problem/Problem";
import Home from "./pages/Home";

export default function App() {
    return (
        <Routes>
            {/* Logged-in app shell — no marketing nav/footer */}
            <Route element={<RequireAuth/>}>
                <Route path="/learn" element={<Learn />} />
                {/* Stripe's checkout success_url points here — a real URL
                    (not just in-app state) so it works as a redirect target,
                    rendered as a modal over the normal Learn page. */}
                <Route path="/learn/thank-you" element={<Learn />} />
                <Route path="/learn/:jobId" element={<Learn />} />
                <Route path="/learn/:jobId/chapter/:chapterIndex" element={<Learn />} />
                <Route path="/learn/:jobId/problem/:problemId" element={<Problem />} />
            </Route>

            {/* Signed-out-only routes — an existing session bounces to /learn
                instead of rendering the landing/login page. */}
            <Route element={<RootGate/>}>
                <Route path="/login" element={<Auth/>}/>
                <Route path="/signup" element={<Auth/>}/>

                <Route element={<Layout/>}>
                    <Route path="/" element={<Home/>}/>
                </Route>
            </Route>

            <Route path="/verify-email" element={<Verify/>}/>

            {/* The marketing site is a single scrolling page now. */}
            <Route path="/about" element={<Navigate to="/" replace />} />
            <Route path="/schools" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
